import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UniqueEntityID } from '@digibricks/domains';
import { CorrectAnswer } from './correct-answer';
export var MultipleChoiceCorrectAnswer = /*#__PURE__*/function (_CorrectAnswer) {
  _inherits(MultipleChoiceCorrectAnswer, _CorrectAnswer);

  var _super = _createSuper(MultipleChoiceCorrectAnswer);

  function MultipleChoiceCorrectAnswer() {
    _classCallCheck(this, MultipleChoiceCorrectAnswer);

    return _super.apply(this, arguments);
  }

  _createClass(MultipleChoiceCorrectAnswer, null, [{
    key: "create",
    value: function create(props) {
      var guardResult = this.validate(props);

      if (guardResult.isFailure) {
        var _guardResult$error;

        return Result.fail((_guardResult$error = guardResult.error) !== null && _guardResult$error !== void 0 ? _guardResult$error : 'Error');
      }

      return Result.ok(new MultipleChoiceCorrectAnswer(props, new UniqueEntityID(props.id ? props.id : null)));
    }
  }]);

  return MultipleChoiceCorrectAnswer;
}(CorrectAnswer);